import type { LiveActivity } from 'expo-widgets'

/**
 * Web-safe boundary for the iOS-only ActivityKit widget.
 *
 * The native implementation imports SwiftUI view managers at module load.
 * Keeping that import out of web bundles lets Tours, including its visual
 * preview routes, render normally while `supportsLiveActivities()` remains
 * the single runtime capability gate.
 */
export interface TagoToursActivityProps {
  schemaVersion: 2
  bookingId: string
  title: string
  originLabel: string
  destinationLabel: string
  startsAt: string
  endsAt: string
  status: string
  emergencyStatus: string
  driverName: string | null
  driverVerified: boolean
  passengerCount: number
  currentStopLabel: string
  nextStopLabel: string
  currentStopPosition: number
  stopCount: number
  etaAt: string | null
  updatedAt: string
}

export const TagoToursActivity = {
  getInstances(): LiveActivity<TagoToursActivityProps>[] {
    return []
  },
  start(): LiveActivity<TagoToursActivityProps> {
    throw new Error('Live Activities are unavailable on web')
  },
}
